import { stringify } from 'qs';
import request from '@/utils/request';

export async function queryApplicationList(params) {
  return request(`/system-applications?${stringify(params)}`);
}

export async function queryApplicationDetail(id) {
  return request(`/system-applications/${id}`);
}

export async function createApplication(params) {
  return request('/system-applications', {
    method: 'POST',
    data: params,
  });
}

export async function updateApplication(params) {
  const { id, ...rest } = params;
  return request(`/system-applications/${id}`, {
    method: 'PUT',
    data: rest,
  });
}

export async function queryApplicationOptions() {
  return request('/system-applications/options');
}

// 批量查询客户的品牌授权情况
export async function queryCustomerBrandAuths(customerCodes) {
  return request(
    `/system-applications/customer-auths?${stringify({
      customer_codes: customerCodes,
    })}`
  );
}

// 设置客户授权的品牌（未选中的品牌会移除该客户）
export async function syncCustomerBrandAuth(customerCode, applicationIds) {
  return request(
    `/system-applications/customer-auths/${encodeURIComponent(customerCode)}`,
    {
      method: 'PUT',
      data: { application_ids: applicationIds },
    }
  );
}

// 取消客户在所有品牌下的授权
export async function revokeCustomerBrandAuth(customerCode) {
  return request(
    `/system-applications/customer-auths/${encodeURIComponent(customerCode)}`,
    {
      method: 'DELETE',
    }
  );
}
